module.exports = __webpack_public_path__ + "img/Sleeves-Front-Gc-Hc-Ic.eb546528.png";